import { render, staticRenderFns } from "./RegraPrestadorServico.vue?vue&type=template&id=f41ce5b8"
import script from "./RegraPrestadorServico.vue?vue&type=script&lang=js"
export * from "./RegraPrestadorServico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports